import React from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import {Labeled, required } from 'admin-on-rest';

const isRequired = (validate) => {
	if (validate === required) return true;
	if (Array.isArray(validate)) {
			return validate.includes(required);
	}
	return false;
};

const FormField = ({ input, ...rest, ...props }) => {
	if (input.props.addField) {
		//using this label required
		return (
			<Field
				{...rest}
				{...input.props}
				toValue={props.toValue}
				name={input.props.source}
				component={input.type}
				label={input.props.label}
				isRequired={isRequired(input.props.validate)} />
		);
	}
	
	if (input.props.addLabel) {
		return (
			<Labeled
				{...rest}
				label={input.props.label}
				toValue={props.toValue}
				source={input.props.source}
				isRequired={isRequired(input.props.validate)}>
				{input}
			</Labeled>
		);
	}
	
	return (typeof input.type === 'string') ? input : React.cloneElement(input, rest);
};
FormField.propTypes = {
	toValue: PropTypes.string,
};

FormField.defaultProps = {
	toValue: '',
};
export default FormField;


// WEBPACK FOOTER //
// ./src/components/image/FormField.js